import { View } from 'react-native';
import { PrimaryButton } from '../buttons/primary-button/PrimaryButton';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { useStore } from 'src/contexts/StoreContext';
import { ACTIVE_TOOLS } from 'src/store/page-project/pageProject.constants';
import { observer } from 'mobx-react-lite';
import { style } from './BottomSheetOrientation.style';
import { Orientation } from '@photosi/expo-photosi-sdk/build/UserImage';
import { BottomBarEditCard } from '../bottom-bar-edit/BottomBarEditCard';
import { useFocusableGroups } from 'src/hooks/useFocusableGroup';
import { configurationTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';

export const BottomSheetOrientation = observer(() => {
  const {
    i18n,
    project: { setActiveTool, activeUserImageArea },
  } = useStore();

  useFocusableGroups([FocusGroups.BOTTOM_SHEET]);

  const ORIENTATION_CARDS = [
    {
      orientation: Orientation.HORIZONTAL,
      uri: '/images/orientation/horizontal.png',
      text: i18n.t('orientation:horizontal'),
      onPress: async () => await activeUserImageArea?.userImage?.applyOrientation(Orientation.HORIZONTAL),
    },
    {
      orientation: Orientation.VERTICAL,
      uri: '/images/orientation/vertical.png',
      text: i18n.t('orientation:vertical'),
      onPress: async () => await activeUserImageArea?.userImage?.applyOrientation(Orientation.VERTICAL),
    },
  ];

  const onPress = () => {
    setActiveTool(ACTIVE_TOOLS.frame);
  };

  return (
    <View style={style.container}>
      <View style={style.cardsWrapper}>
        {ORIENTATION_CARDS.map((card, index) => {
          return (
            <BottomBarEditCard
              card={card}
              isSelected={activeUserImageArea?.userImage?.orientation === card.orientation}
              key={card.text}
              focusId={configurationTestID(TestIDs.ORIENTATION, card.orientation)}
              focusOrder={index}
            />
          );
        })}
      </View>
      <View style={style.ctaWrapper}>
        <PrimaryButton
          focusGroup={FocusGroups.BOTTOM_SHEET}
          focusOrder={ORIENTATION_CARDS.length}
          focusId={configurationTestID(TestIDs.ORIENTATION, TestIDs.CLOSE)}
          onPress={async () => onPress()}
          text={i18n.t('adjustments:close')}
        />
      </View>
    </View>
  );
});
